module.exports = __webpack_public_path__ + "static/media/SharpSansDispNo1-Semibold_1.0b4e3c73.ttf";